export default __webpack_public_path__ + "static/media/86.06c5cbd7.jpg";